import * as yup from "yup";
import { validationArraySelect, validationNotEmpty, validationWithoutSpace, } from "./defaultValidations";

export default yup.object({
  policyName: validationWithoutSpace("Policy Name"),
  policyDescription: validationNotEmpty("Policy Description"),
  addUser: validationArraySelect("Add User Policy"),
});